import { z } from 'zod';

/**
 * ADR-155 §2 / §6 — the contract-addressed envelope, client side.
 *
 * Every employment event may name the episode (contract) it addresses. The
 * field is optional on every wrapper schema: the Contracts tab supplies it
 * (the acting contract), the card shortcuts resolve the person's only open
 * contract, and the server's resolver (radar-api guards.resolveTargetEpisodeId)
 * decides what an absent id means. A leg that addresses the contract a
 * previous leg CREATED writes the batch placeholder instead — the trigger
 * controller resolves it from that leg's return.
 */
export const employmentEpisodeIdSchema = z.uuid().optional();

/** `{ employmentEpisodeId }` when the validated payload carries one, else `{}` — spread into a leg payload. */
export const withEpisode = (validated) =>
  (validated?.employmentEpisodeId ? { employmentEpisodeId: validated.employmentEpisodeId } : {});

/** The successor contract of THIS batch — the episode the REHIRE / HIRE_FINALIZED leg returned. */
export const SUCCESSOR_EPISODE_PLACEHOLDER = '${employmentEpisodeId}';
